import { styled as muiStyled } from '@mui/material/styles';

// Utility to ignore all props that start with `$`
const styled = (Component) =>
	muiStyled(Component, {
		shouldForwardProp: (prop) => !prop.startsWith('$') // Ignore props starting with `$`
	});

export default styled;
